import React, { useContext, useState, useEffect } from "react";
import { AddUserDataContext } from "context/AddUserContext";
import { VALIDATIONS, INPUT_TYPES } from "utils/CommonConstants";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import RadioButton from "sub_components/Common/Radio";
import TextInput from "sub_components/Common/BloxTextInput";
import styled from "styled-components";

const CHOICES = {
  OWNER: "Owner",
  MEMBER: "Member",
  SHARED_USER: "Shared User",
};

const OPTIONS = [
  { name: CHOICES.OWNER, value: CHOICES.OWNER },
  { name: CHOICES.MEMBER, value: CHOICES.MEMBER },
  { name: CHOICES.SHARED_USER, value: CHOICES.SHARED_USER },
];

const UserDetailStyle = styled.div`
	height: 150px;
	position: relative;
	.blox-text-input {
		width: 100%;
		margin-bottom: 8px;
	}
	.ScrollbarsCustom-Track {
		right: -20px !important;
		top: 0px !important;
	}
	.ScrollbarsCustom-ThumbY {
		background-color: ${(props) => props.theme.account} !important;
		width: 6px !important;
	}
	.ScrollbarsCustom-TrackY:before {
		border-left: none;
	}
	.ScrollbarsCustom-TrackY {
		background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
		box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
			1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
		width: 6px !important;
	}

	.radio-wrapper {
			width: 450px;
			margin-top:10px;
			.radio-selection {
				.radio-label{
					margin 4px 12px 10px 45px;
				}
				.check{
					margin-top:-3px;
				}
			}
		}

	@media screen and (min-width: ${(props) =>
    props.theme.res.medium}) and (max-width: ${(props) =>
  props.theme.res.high}) {
		height: 220px;
		.blox-text-input {
			margin-bottom: 16px;
			max-height: 52px;
		}
		.info-message {
			position: absolute;
			font-size: 11px !important;
			bottom: -95px;
		}
		.ScrollbarsCustom-Track {
			right: -30px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${(props) => props.theme.account} !important;
			width: 10px !important;
		}
		.radio-wrapper {
				margin-top:15px;
				.radio-selection {
					margin-bottom: 15px;
					.radio-label{
						margin 4px 12px 0 45px;
					
					}
					.check{
						margin-top:-3px;
					}
				}
			}
		}
      @media screen and (min-width: ${(props) => props.theme.res.high}) {
		height: 390px;
		.blox-text-input {
			margin-bottom: 50px;

		}
		.info-message {
			position: absolute;
			bottom: -105px;
		}
		.ScrollbarsCustom-Track {
			right: -30px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${(props) => props.theme.account} !important;
			width: 10px !important;
		}
		.radio-wrapper {
				margin-top:15px;
				.radio-selection {
					margin-bottom: 20px;
					.radio-label{
						margin 4px 12px 0 45px;
					}
					.check{
						margin-top:-3px;
					}
				}
			}
		}
	}
	}
	
`;

export const UserDetailScreen = ({ owners }) => {
  const { inputs, change } = useContext(AddUserDataContext);
  const [canAddOwners, setOwners] = useState(false);

  function ownersCheck() {
    if (owners?.length <= 2) {
      setOwners(true);
    } else {
      change({ target: { name: "role", value: "member" } });
    }
  }

  function handleChange(role) {
    change({ target: { name: "role", value: role } });
  }

  useEffect(() => {
    ownersCheck();
  }, [owners]);

  return (
    <UserDetailStyle>
      <ScrollView>
        <TextInput
          placeholder=""
          type={INPUT_TYPES.INPUT}
          label="First Name"
          name="firstname"
          value={inputs.firstname}
          validations={[
            VALIDATIONS.AT_LEAST_ONE_CHAR,
            VALIDATIONS.NO_SPECIAL_CHARACTERS,
          ]}
          onChange={change}
          active={true}
          hideCheckmark
          cypressId="create-user-firstname"
        />
        <TextInput
          placeholder=""
          type={INPUT_TYPES.INPUT}
          label="Last Name"
          name="lastname"
          value={inputs.lastname}
          validations={[
            VALIDATIONS.AT_LEAST_ONE_CHAR,
            VALIDATIONS.NO_SPECIAL_CHARACTERS,
          ]}
          onChange={change}
          active={true}
          hideCheckmark
          cypressId="create-user-lastname"
        />
        <TextInput
          placeholder=""
          type={INPUT_TYPES.INPUT}
          label="Email"
          name="email"
          value={inputs.email}
          validations={[VALIDATIONS.VALID_EMAIL]}
          onChange={change}
          active={true}
          hideCheckmark
          cypressId="create-user-email"
        />
        {canAddOwners && (
          <>
            <div className="label-row labels22">Select a role </div>
            <RadioButton
              callback={handleChange}
              name="roleOptions"
              value={inputs.role}
              hidden={false}
              toggle={true}
              options={OPTIONS}
              cypressId="role"
              id="role"
            />
          </>
        )}
      </ScrollView>
    </UserDetailStyle>
  );
};
